import Spinner from 'react-bootstrap/Spinner';

function Loading({ size, text }) {
  return (
    <div className='d-flex flex-column justify-content-center align-items-center'>
      <Spinner
        animation='border'
        role='status'
        style={{ width: size, height: size }}
      >
        <span className='visually-hidden'>Loading...</span>
      </Spinner>
      <span className='mt-3 fs-5'>{text}</span>
    </div>
  );
}

export default Loading;
